import React, { FC } from 'react'
import classNames from 'classnames'
import text from 'styles/utility/text.module.scss'
import { Card, CardInner, StaffPushCardListDetail } from 'components/Card'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Spacer } from 'components/Utility'
import { SubDescription } from 'components/Typography'
import { staffPushMenus } from 'constants/menus'
import { getStaffPushSettings, getStoreRef } from 'reducks/auth/selectors'
import { StaffPushSettingType } from 'types/staff'
import { useQueryStoreName } from 'hooks/store'

const StaffPushCard: FC = React.memo(() => {
  const staffPushSettings: StaffPushSettingType[] = useSelector((state: State) => getStaffPushSettings(state))
  const storeRef = useSelector((state: State) => getStoreRef(state))
  const storeName = useQueryStoreName(storeRef)

  if (!staffPushSettings || staffPushSettings.length <= 0) {
    return <></>
  }

  return (
    <Card>
      <CardInner>
        <Spacer size={4} />
        <h3 className={classNames(text.font_xxlarge, text.align_center, text.font_bold)}>アプリプッシュ通知設定</h3>
        <Spacer size={20} />
        <p className={classNames(text.font_small, text.align_center, text.color_grey_01)}>
          設定する店舗：
          <span className={classNames(text.font_default, text.font_bold)}>{storeName}</span>
        </p>
        <Spacer size={12} />
        <SubDescription description={'別の店舗の設定を行う場合は、店舗を切り替えてから設定してください。'} />
        <Spacer size={20} />
        {staffPushMenus.map((menu) => (
          <StaffPushCardListDetail key={menu.permission} label={menu.label} permission={menu.permission} />
        ))}
      </CardInner>
    </Card>
  )
})

export default StaffPushCard
